module.exports = __webpack_public_path__ + "img/SPC_Sword4 Clean OneMaterial.59998419.png";